var _g, _path, _path2, _path3, _path4, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestGreenCardError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 154,
    viewBox: "0 0 255 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dRGCE)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 31,
    width: 223,
    height: 119,
    rx: 5,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 83.18H37a4.505 4.505 0 01-4.5-4.5V50.675a4.506 4.506 0 014.5-4.5h34a4.505 4.505 0 014.5 4.5V78.68a4.506 4.506 0 01-4.5 4.5zM37 47.176a3.503 3.503 0 00-3.5 3.5V78.68a3.504 3.504 0 003.5 3.5h34a3.504 3.504 0 003.5-3.5V50.676a3.505 3.505 0 00-3.5-3.5H37zm-6.25 46.505a3.25 3.25 0 100 6.501h164.5a3.249 3.249 0 003.25-3.25 3.249 3.249 0 00-3.25-3.25H30.75z",
    fill: "var(--color-secondary-light)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.25 59.677a3.25 3.25 0 000 6.5h70.5a3.249 3.249 0 002.298-5.548 3.249 3.249 0 00-2.298-.952h-70.5zm0 17.003a3.25 3.25 0 100 6.5h107.5a3.248 3.248 0 003.25-3.25 3.249 3.249 0 00-3.25-3.25H86.25z",
    fill: "var(--color-primary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 110.683a3.252 3.252 0 00-2.298 5.549c.61.609 1.436.952 2.298.952h164.5a3.251 3.251 0 000-6.501H30.75zm0 17.002a3.252 3.252 0 00-2.298 5.549c.61.61 1.436.952 2.298.952h164.5a3.247 3.247 0 003.25-3.25 3.25 3.25 0 00-3.25-3.251H30.75zm34.606-66.583H62.51l-.791-1.934c-.813-1.989-2.754-3.273-4.945-3.273h-6.04c-2.19 0-4.13 1.284-4.944 3.273l-.792 1.934h-2.846a.56.56 0 00-.554.694l.285 1.116a.568.568 0 00.554.422h.954a2.929 2.929 0 00-1.05 2.232v2.232c0 .75.293 1.426.761 1.95v2.514c0 .821.682 1.488 1.522 1.488h1.522c.84 0 1.521-.667 1.521-1.488v-1.488H59.84v1.488c0 .821.682 1.488 1.522 1.488h1.522c.84 0 1.522-.667 1.522-1.488v-2.514c.468-.523.76-1.2.76-1.95v-2.232a2.93 2.93 0 00-1.049-2.232h.954c.262 0 .49-.174.554-.422l.285-1.116a.561.561 0 00-.554-.694zm-16.742-.829a2.283 2.283 0 012.12-1.403h6.04c.933 0 1.772.556 2.119 1.403l.947 2.317H47.666l.948-2.317zm-2.47 7.516c-.912 0-1.521-.594-1.521-1.484s.609-1.483 1.522-1.483 2.282 1.335 2.282 2.225c0 .89-1.37.742-2.282.742zm15.218 0c-.913 0-2.282.148-2.282-.742s1.37-2.225 2.282-2.225c.913 0 1.522.593 1.522 1.483 0 .89-.609 1.484-1.522 1.484z",
    fill: "var(--color-secondary-light)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.663 34.538c-1.103 0-1.839-.735-1.839-1.839V19.461c0-1.104.736-1.84 1.839-1.84s1.839.736 1.839 1.84v13.238c0 1.104-.736 1.84-1.839 1.84zm.001 9.562c-.368 0-1.103 0-1.471-.367-.368-.368-.368-.736-.368-1.471 0-.368 0-1.103.368-1.471.735-.735 1.839-.735 2.574 0 .368.368.368.736.368 1.471 0 .368-.368 1.103-.736 1.47.368.369-.367.369-.735.369z",
    fill: "#F48026"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 30,
    r: 29,
    stroke: "#F48026",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dRGCE",
    x: 0,
    y: 31,
    width: 227,
    height: 123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestGreenCardError);
export default __webpack_public_path__ + "static/media/request-green-card-error.9eb83b2613e09c43a2a3f1b98d2b2db3.svg";
export { ForwardRef as ReactComponent };